// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-panel-enter {\n  transform: translateX(744px);\n}\n.detail-panel-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n}\n.detail-panel-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n.detail-panel-exit-active {\n  opacity: 0;\n  transform: translateX(-744px);\n}", ""]);
// Exports
module.exports = exports;
